<template>
  <base-slide-panel :isOpen="panelOpen" @closePanel="togglePanel">
    <template slot="header">
      <div class="h-16 bg-secondary dark:bg-darkblue-600 flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <base-icon name="filter"/>
          <h2 class="font-bold ml-2">{{ $t('app.filter_by') }}</h2>
        </div>
        <span class="cursor-pointer" @click="togglePanel">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4 dark:bg-darkblue-800 dark:text-darkblue-200">
        <el-form
          ref="ruleForm"
        >
          <div class="lg:mb-2">

            <!-- #region Cantidad -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.invoices_issuing.step4.cantidad_min_max') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="cantidadMin">
                        <el-input clearable class="w-full" v-model="form.cantidadMin.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="cantidadMax">
                        <el-input clearable class="w-full" v-model="form.cantidadMax.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->
            
            <!-- #region Precio Unitario -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.invoices_issuing.step4.precio_unitario_min_max') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="precioUnitarioMin">
                        <el-input clearable class="w-full" v-model="form.precioUnitarioMin.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="precioUnitarioMax">
                        <el-input clearable class="w-full" v-model="form.precioUnitarioMax.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <!-- #region Total -->
            <div>
              <base-collapsible class="mb-3"
                customContent="bg-white dark:bg-darkblue rounded-lg border-solid border-primary-100 dark:border-darkblue-600 border p-4 mt-2">
                <template slot="headerRight">
                  <div class="flex flex-col py-2">
                    <h2 class="dark:text-darkblue-100">{{ $t('invoices.invoices_issuing.step4.total_min_max') }}</h2>
                  </div>
                </template>
                <template slot="content">
                  <div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.min') }}</label>
                      <el-form-item prop="totalMin">
                        <el-input clearable class="w-full" v-model="form.totalMin.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                    <div>
                      <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('app.max') }}</label>
                      <el-form-item prop="totalMax">
                        <el-input clearable class="w-full" v-model="form.totalMax.value" min="0" max="9999999999"
                          type="number" />
                      </el-form-item>
                    </div>
                  </div>
                </template>
              </base-collapsible>
            </div>
            <!-- #endregion -->

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.cod_producto') }}</label>
              <el-form-item prop="codProducto">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.codProducto.value"
                  maxlength="50"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('products.ItemDescription')}}</label>
              <el-form-item prop="descripcion">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.descripcion.value"
                  maxlength="200"
                />
              </el-form-item>
            </div>

            <div>
              <label class="text-sm font-semibold text-secondary-600 block mb-1">{{ $t('invoices.invoices_issuing.descuento') }}</label>
              <el-form-item prop="descuento">
                <el-input
                  clearable
                  class="w-full"
                  v-model="form.descuento.value"
                  maxlength="255"
                />
              </el-form-item>
            </div>
            
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button @click="togglePanel" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
      <base-button mode="secondary-phantom-blue" class="w-full" :text="$t('app.apply')" @click="applyFilters"/>
    </template>
  </base-slide-panel>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  /* eslint-disable camelcase */
  name: 'filter-panel',
  props: {
    panelOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
      },
      vuexnamespace: 'invoicesIssuing/4',
      isOpen: this.panelOpen,
      form: {
        codProducto: { label: i18n.t('invoices.invoices_issuing.cod_producto'), value: '' },
        descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
        cantidad: { label: i18n.t('invoices.invoices_issuing.step4.cantidad'), value: '' },
        cantidadMax: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_max'), value: '' },
        cantidadMin: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_min'), value: '' },
        precioUnitarioMax: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_max'), value: '' },
        precioUnitarioMin: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_min'), value: '' },
        totalMax: { label: i18n.t('invoices.invoices_issuing.step4.total_max'), value: '' },
        totalMin: { label: i18n.t('invoices.invoices_issuing.step4.total_min'), value: '' },
        descuento: { label: i18n.t('invoices.invoices_issuing.descuento'), value: '' },
        cuota: { label: i18n.t('invoices.invoices_issuing.discount_cuota'), value: '' },
      },
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ]
    }
  },
  mounted: async function () {
  },
  computed: {
  },
  watch: {
    panelOpen: {
      handler: 'panelOpenHandler'
    }
  },
  methods: {
    panelOpenHandler: function (data) {
      const _temp = this.$store.getters[this.vuexnamespace + '/getMasterFilters']
      if (_temp) {
        this.resetForm()
        this.form.codProducto.value = _temp.codProducto !== undefined && _temp.codProducto ? _temp.codProducto.value : ''
        this.form.descripcion.value = _temp.descripcion !== undefined && _temp.descripcion ? _temp.descripcion.value : ''
        this.form.cantidad.value = _temp.cantidad !== undefined && _temp.cantidad ? _temp.cantidad.value : ''
        this.form.cantidadMax.value = _temp.cantidadMax !== undefined && _temp.cantidadMax ? _temp.cantidadMax.value : ''
        this.form.cantidadMin.value = _temp.cantidadMin !== undefined && _temp.cantidadMin ? _temp.cantidadMin.value : ''
        this.form.precioUnitarioMax.value = _temp.precioUnitarioMax !== undefined && _temp.precioUnitarioMax ? _temp.precioUnitarioMax.value : ''
        this.form.precioUnitarioMin.value = _temp.precioUnitarioMin !== undefined && _temp.precioUnitarioMin ? _temp.precioUnitarioMin.value : ''
        this.form.totalMax.value = _temp.totalMax !== undefined && _temp.totalMax ? _temp.totalMax.value : ''
        this.form.totalMin.value = _temp.totalMin !== undefined && _temp.totalMin ? _temp.totalMin.value : ''
        this.form.descuento.value = _temp.descuento !== undefined && _temp.descuento ? _temp.descuento.value : ''
        this.form.cuota.value = _temp.cuota !== undefined && _temp.cuota ? _temp.cuota.value : ''
      }
    },
    togglePanel: function () {
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    },
    resetForm: function () {
      this.form = {
        codProducto: { label: i18n.t('invoices.invoices_issuing.cod_producto'), value: '' },
        descripcion: { label: i18n.t('invoices.invoices_issuing.descripcion'), value: '' },
        cantidad: { label: i18n.t('invoices.invoices_issuing.step4.cantidad'), value: '' },
        cantidadMax: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_max'), value: '' },
        cantidadMin: { label: i18n.t('invoices.invoices_issuing.step4.cantidad_min'), value: '' },
        precioUnitarioMax: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_max'), value: '' },
        precioUnitarioMin: { label: i18n.t('invoices.invoices_issuing.step4.precio_unitario_min'), value: '' },
        totalMax: { label: i18n.t('invoices.invoices_issuing.step4.total_max'), value: '' },
        totalMin: { label: i18n.t('invoices.invoices_issuing.step4.total_min'), value: '' },
        descuento: { label: i18n.t('invoices.invoices_issuing.descuento'), value: '' },
        cuota: { label: i18n.t('invoices.invoices_issuing.discount_cuota'), value: '' },
      }
    },
    applyFilters: function () {
      this.$store.commit(this.vuexnamespace + '/setMasterFilters', this.form)
      this.$emit('applyFilters', true)
      this.isOpen = !this.isOpen
      // this.resetForm()
      this.$emit('togglePanel')
    }
  }
}
</script>

<style lang="scss" scoped></style>
